// [Metric] Mapeo short_name → action_id (tu catálogo BIN)
export const actionMap: Record<string, number> = {
    mi_tablero: 1,
    mis_folios: 2,
    mis_cotizaciones: 3,
    autos_online: 4,
    rc_contratista_online: 5,
    gmm_online: 6,
    camiones_individual: 7,
    mis_clientes: 8,
    mis_polizas: 9,
    mis_recibos_pendientes: 10,
    mis_renovaciones: 11,
    mis_claves_de_agente: 12,
    soporte: 13,
    log_out: 14,
    cambio_de_agente: 15,
    cambio_de_cartera: 16,
    notificaciones: 17,
    dark_mode: 18,
    perfil: 19
};